<template lang="pug">
  el-menu-item(
    v-if="showItemDynamically(user, dynamicViewsConstants.resource_names.CUSTOMER, ['index'])"
    index='/customers'
  )
    .img-wrapper
      img(src="@src/assets/sidebar/customers.svg")
    router-link.sub-menu-link(to="/customers")
      span  {{ $t('sidebar.customers') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "CustomersItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
